import { DatatableSort } from "@/model/dto/datatable-sort"
import { Filter } from "@/model/dto/filter"
import ActivityHistory from "@/model/entity/activity-history/activity-history"
import {AxiosPromise} from "axios"
import { plainToClass } from "class-transformer"
import {EntityService} from "../entity-service"
import {Page} from "@/model/dto/page"
import ActivityHistoryLog from "@/model/entity/activity-history/activity-history-log"
import ACTIVITY_TYPE from "@/model/entity/activity-history/activity-type"
import AddressExportLog from "@/model/entity/activity-history/address-export-log"
import CollectionRequestExportLog from "@/model/entity/activity-history/collection-request-export-log"
import LoginAsOtherLog from "@/model/entity/activity-history/login-as-other-log"
import PacelExportLog from "@/model/entity/activity-history/parcel-export-log"
import SessionChangeLog from "@/model/entity/activity-history/session-change-log"

class ActivityHistoryService extends EntityService<ActivityHistory> {
  constructor() {
    super("activity_history", ActivityHistory)
  }

  public getPage(
    page: number,
    rows: number,
    filters: Filter[],
    sort?: DatatableSort
  ): AxiosPromise<Page<ActivityHistory>> {
    return this.$http.get(`${this.path}/search${this.buildQueryParams(filters, page - 1, rows, sort)}`)
      .then(response => {
        response.data.content = plainToClass(this.classType, response.data.content)
        return response
      })
  }

  public getDetails(activityHistory: ActivityHistory): AxiosPromise<ActivityHistoryLog> {
    return this.$http.post(`${this.path}/findDetails?rows=1&page=0`, activityHistory).then(response => {
      switch (activityHistory.activityTypeEnum) {
        case ACTIVITY_TYPE.LOGIN_AS_OTHER:
          response.data = plainToClass(LoginAsOtherLog, response.data.content[0])
          break
        case ACTIVITY_TYPE.PARCEL_EXPORT:
          response.data = plainToClass(PacelExportLog, response.data.content[0])
          break
        case ACTIVITY_TYPE.SESSION_CHANGE:
          response.data = plainToClass(SessionChangeLog, response.data.content[0])
          break
        case ACTIVITY_TYPE.OFFICE_EDIT:
          response.data = plainToClass(SessionChangeLog, response.data.content[0])
          break
        case ACTIVITY_TYPE.PARCEL_RANGE_ADD:
          response.data = plainToClass(SessionChangeLog, response.data.content[0])
          break
        default:
          throw new Error("Unsported activity detail")
      }
      return response
    })
  }

  public buildQueryParams(filters: Filter[], page?: number, rows?: number, sort?: DatatableSort) {
    let query = "?"

    if (exists(page)) {
      query = `${query}page=${page}&`
    }

    if (exists(rows)) {
      query = `${query}rows=${rows}&`
    }

    filters.forEach(filter => {
      const trimmed = trimDeep(filter)
      query = `${query}${trimmed.field}=${trimmed.value}&`
    })

    return query
  }
}

interface IActivityHistoryService extends EntityService<ActivityHistory> {
}

const activityHistoryService = new ActivityHistoryService()


export {
  activityHistoryService,
  IActivityHistoryService,
  ActivityHistoryService
}
